import { useTranslation } from "react-i18next"

import {
    Button,
    EButtonSize,
    EButtonVariant,
    ETypographyAlignment,
    ETypographyColor,
    ETypographyFamily,
    ETypographySize,
    ETypographyTag,
    ETypographyWeight,
    Typography
} from "@/3514/components"
import Modal from "@/shared/modal"

import "./styles.scss"

type Props = {
    isOpen: boolean
    initialText: string
    onClose: () => void
    onSubmit: () => void
}

export const BehavioralDeleteModal = ({ isOpen, initialText, onClose, onSubmit }: Props) => {
    const { t } = useTranslation()

    return (
        <Modal
            onClose={onClose}
            show={isOpen}
            disableBodyScroll
            enableOutSideClick={false}
            closeOnEscapePress={false}
            headerContent={
                <Typography
                    text={t("Delete Entry?")}
                    className="p-3 m-0"
                    color={ETypographyColor.Black}
                    weight={ETypographyWeight.Medium}
                    family={ETypographyFamily.DmSerif}
                    alignment={ETypographyAlignment.Center}
                    size={ETypographySize.Heading2}
                    tag={ETypographyTag.Heading2}
                />
            }
            modalBodyClass="behavioral-delete-modal"
        >
            <div className="behavioral-delete-modal__body text-center">
                <p className="text-gray-100 mb-1 font-extrabold">{t("Warning")}:</p>
                <p className="text-gray-100 text-center mb-2">
                    {t("Are you sure you want to delete your previous entry?")}
                </p>
                <p className="text-gray-200 font-italic">&quot;{initialText}&quot;</p>

                <div className="text-center mb-2">
                    <Button onClick={onSubmit}>{t("Delete")}</Button>
                </div>

                <div className="text-center">
                    <Button variant={EButtonVariant.Outlined} size={EButtonSize.Small} onClick={onClose}>
                        {t("No, keep my entry.")}
                    </Button>
                </div>
            </div>
        </Modal>
    )
}
